import React, { useEffect, useRef, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import SideNavBar from "./SideNavBar";
import menu from "../../assets/dashboard/menu-left.svg";
import logoMobile from "../../assets/dashboard/logoMobile.png";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ChangePassword from "./ChangePassword";
const MAX_MOBILE_SCREEEN_SIZE = process.env.REACT_APP_MAX_MOBILE_SCREEN_SIZE;

const MainLayout = ({ user }) => {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < MAX_MOBILE_SCREEEN_SIZE
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < MAX_MOBILE_SCREEEN_SIZE);
      setIsSidebarVisible(window.innerWidth > MAX_MOBILE_SCREEEN_SIZE);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  const toggleDropdown = () => setIsDropdownVisible(!isDropdownVisible);

  const handleSignOut = () => {
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("user");
    navigate("/signin");
    window.location.reload();
  };
  const handleChangePassword = () => {
    setOpenChangePassword(true);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="flex h-screen overflow-hidden bg-white w-full">
      <SideNavBar
        isSidebarVisible={isSidebarVisible}
        onClose={() => setIsSidebarVisible(false)}
        userRole={user?.userRole}
      />

      <div className="flex-1 flex flex-col transition-all duration-300 overflow-hidden">
        <header className="h-16 bg-white px-4 md:px-10 shadow-md flex items-center justify-between sticky top-0 z-20 w-full">
          <div className="flex items-center py-4.5">
            {!isMobile ? (
              <img
                src={menu}
                alt="Toggle Menu"
                className="w-7 h-7 cursor-pointer"
                onClick={toggleSidebar}
              />
            ) : (
              <div className="flex gap-2 justify-start items-center">
                <img
                  src={menu}
                  alt="Toggle Menu"
                  className="w-7 h-7 cursor-pointer"
                  onClick={toggleSidebar}
                />
                <img src={logoMobile} alt="Avana Logo" className="w-20 h-10" />
              </div>
            )}
          </div>

          <div className="relative px-2">
            <div
              className="flex items-center gap-3 cursor-pointer"
              onClick={toggleDropdown}
            >
              <div className="w-8 h-8 rounded-full bg-gray-500 text-white flex items-center justify-center text-sm">
                {user?.firstName[0] || ""}
                {user?.lastName[0].toUpperCase() || ""}
              </div>
            </div>

            {isDropdownVisible && (
              <div className="fixed inset-0 bg-black bg-opacity-25 flex justify-center z-50">
                <div
                  ref={dropdownRef}
                  className="absolute right-14 top-14 mt-2 w-fit bg-white shadow-lg rounded-lg z-20 space-y-1"
                >
                  <div className="px-4 pt-3 pb-2 ">
                    <div className="text-sm text-gray-500 font-medium">
                      Signed in as
                    </div>
                    <div className="text-sm text-text1 -mt-1">{user.email}</div>
                  </div>
                  <hr />
                  <div
                    className="px-4 py-2 text-gray-700 font-normal text-sm cursor-pointer"
                    onClick={handleChangePassword}
                  >
                    Change Password
                  </div>
                  <hr />
                  <div
                    className="px-4 py-2 text-gray-700 font-normal text-sm cursor-pointer"
                    onClick={() => {
                      setIsDropdownVisible(false);
                      handleSignOut();
                    }}
                  >
                    Sign out
                  </div>
                </div>
              </div>
            )}
          </div>
        </header>

        <main className="flex-1 sm:px-6 px-4 py-6 overflow-y-auto bg-white w-full">
          <Outlet />
        </main>
        {openChangePassword && (
          <ChangePassword handleClose={() => setOpenChangePassword(false)} />
        )}
        {/* React Toastify Container */}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          closeOnClick
          pauseOnHover
          draggable
          theme="light"
        />
      </div>
    </div>
  );
};

export default MainLayout;
